var _defs, _path, _path2, _polygon, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas6Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 52.41px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 37.82px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #323a89;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.45,949.77H60.07c-11.72,0-21.23-9.47-21.29-21.19-1.39-290.85-2.79-581.69-4.18-872.54-.06-11.8,9.49-21.39,21.29-21.39h355.81c5.37,0,10.54,2.03,14.47,5.68,33.89,31.41,67.78,62.83,101.67,94.24,3.94,3.65,9.11,5.68,14.47,5.68h522.4c11.76,0,21.29,9.53,21.29,21.29v766.95c0,11.76-9.53,21.29-21.29,21.29h-312.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m489.82,948.58l-428.39,1.19c-14.88,0-26.93-12.05-26.93-26.93V351.97c0-14.88,12.06-26.93,26.93-26.93h993.23c14.88,0,26.93,12.06,26.93,26.93v570.87c0,14.88-12.06,26.93-26.93,26.93l-420.71-1.19"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "493.59 813.58 560.25 548.75 634.95 811.42 493.59 813.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m563.29,726.15v392.77-392.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas6Icon);
export default __webpack_public_path__ + "static/media/pas6Icon.5de010e85f3fd76e6b6bc382f39ff563.svg";
export { ForwardRef as ReactComponent };